import * as Handlebars from 'handlebars';
import { EventManager } from '@fnv-core/events';
import { isIOS, updateCurrentUrlParameter } from '@fnv-core/utils';
import { PluginManager } from '@fnv-static/plugins';
import { EVENT_PAGESLIDER_ITEMS_LOADED } from '@fnv-static/slider';
import { getAllUrlParams } from './jslibs/urlparams';
import { registerHandlebarsHelpers } from './helpers/handlebars-helpers';

require('jquery-ellipsis');

interface EllipsisOptions{
  count? : number;
  type? : string;
}

declare global {
  interface JQuery<TElement = HTMLElement> {
    ellipsis(options?: EllipsisOptions): this;
  }
}

export interface IFilterSearchInfo {
  itemTemplate : any;
  groupTemplate : any;
  loadMoreTemplate : any;
  noResultsTemplate : any;
  dateField : any;
  pageNo: number;
  currentMonth : string;
  groupMode : string;
  maxItems : number;
  resultsCount : number;

  filterElement : any;

  storeTimer: any;
  searchIndex : number;
}

let developMode = false;

function setupFilterCategoryAccordion() {
  $(".filter__facet-accordion-toggle").off("click");
  $(".filter__facet-accordion-toggle").on("click", function(event) {
    event.preventDefault();
    $(this).closest(".filter__facet-accordion").toggleClass("filter__facet-accordion-closed");
    return false;
  });
}

function setupFilterMobile() {
    if(isIOS() && $(".filter__filter-options-container").length > 0) {

      // The below is a fix for scrolling the body behind a position-fixed overlay
      // Tne positive side-effect is that this also fixes the bug on ios that an overlay can hang
      // after triggering the "momentum scrolling" effect and trying to move the other way
      // (somehow this triggers scrolling the body instead of the overlay)
      (function () { 
        var _overlay = $(".filter__filter-options-container")[0];  
        var _clientY : number = null; // remember Y position on touch start
          
        function isOverlayTotallyScrolled() {           
          // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions      
          return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;     
        }
    
        _overlay.addEventListener('touchstart', function (event : TouchEvent) {
          
          if (event.targetTouches.length === 1) {      
            _clientY = event.targetTouches[0].clientY;      
          }
          
        }, false);
          
        function disableRubberBand(event : TouchEvent) {
          
          var clientY = event.targetTouches[0].clientY - _clientY;
          
          if (_overlay.scrollTop === 0 && clientY > 0) {     
            // element is at the top of its scroll     
            event.preventDefault();     
          }
          
          if (isOverlayTotallyScrolled() && clientY < 0) {      
            //element is at the top of its scroll        
            event.preventDefault();      
          }     
        }
          
        _overlay.addEventListener('touchmove', function (event : TouchEvent) {     
          if (event.targetTouches.length === 1) {     
            disableRubberBand(event);     
          }
          
        }, false);
          
      }());
    }
}

function resetFilter(filterSearchInfo : IFilterSearchInfo) {
  const pageNoUrl : string = "/" + filterSearchInfo.pageNo;
  const urlPostFix = "search=" + $(".filter__search-input:not(.filter__search-input-menu)").val();
  const url = $(filterSearchInfo.filterElement).find(".filter__results").attr("data-search-url") + pageNoUrl + "?" + urlPostFix;

  filterSearchInfo.searchIndex++;
  const oldSearchIndex : number = filterSearchInfo.searchIndex;

  filterSearchInfo.resultsCount = 0;
  filterSearchInfo.pageNo = 1;
  filterSearchInfo.currentMonth = "";
  storeTimerFunction(filterSearchInfo, url, oldSearchIndex, true, 1);
}

export function doFilter(initFilter : boolean, keepResultsUntilCallback : boolean, triggerWithDelay : boolean, filterSearchInfo : IFilterSearchInfo) {
  
  let isAndOrFacetsSearch = false;
  let addAdditionalActiviteitenFacets = false;
  let filterContainer = $(".filter__container");
  if (filterContainer.length > 0) {
    isAndOrFacetsSearch = $(filterContainer[0]).attr("data-and-or-facets").toLowerCase() === "true";
  }

  if (filterContainer.length > 0) {
    if ($(filterContainer[0]).attr("data-activiteiten-facets") !== undefined) {
      addAdditionalActiviteitenFacets = ($(filterContainer[0]).attr("data-activiteiten-facets") || "").toLowerCase() === "true";
    }
  }

  filterSearchInfo.searchIndex++;
  let oldSearchIndex : number = filterSearchInfo.searchIndex;

  if (typeof filterSearchInfo.storeTimer != "undefined") {
    clearTimeout(filterSearchInfo.storeTimer);
    filterSearchInfo.storeTimer = undefined;
  }

  if (initFilter) {
    filterSearchInfo.resultsCount = 0;
    filterSearchInfo.pageNo = 1;
    filterSearchInfo.currentMonth = "";

    if (!keepResultsUntilCallback) {
      $(filterSearchInfo.filterElement).find(".filter__results").html("");          
    }
  } else {
    $(filterSearchInfo.filterElement).find(".filter__load-more-container").remove();
  }

  let facetFilters : any = {};
  let filterCategories = "";
  let filterCategoryCodeNames = "";
  $(".filter__filter-options-container form input:checked").each((index: number, element) => {
    let facet : string = $(element).attr("name");
   
    let existingValues = "";
    if (typeof facetFilters[facet] !== "undefined") {
      existingValues = facetFilters[facet] + ",";
    }
    facetFilters[facet] = existingValues + $(element).val();

    if (filterCategories != "") {
      filterCategories += ",";
      filterCategoryCodeNames += ",";
    }
    filterCategories += $(element).val();
    filterCategoryCodeNames += $(element).attr('id').replace("facetcategorie-", "");
  });

  let urlPostFix = "";
  for (let facet in facetFilters) {
    if (facetFilters.hasOwnProperty(facet)) {

      if (urlPostFix != "") {
        urlPostFix += "&";  
      }
      urlPostFix += facet + "=" + facetFilters[facet];
    }
  }

  const documentCategoryIdsFacet = "documentcategoryids";
  
  const selectedCategoryIds = $(filterSearchInfo.filterElement).find(".filter__results").attr("data-documentcategories");
  if (selectedCategoryIds) {

    if (urlPostFix != "") {
      urlPostFix += "&";
    }
    urlPostFix += documentCategoryIdsFacet + "=" + selectedCategoryIds;
  }

  if ($(".filter__search-sort").length > 0) {
    const sortOption = $(".filter__search-sort-option.active").attr("data-sort");

    if (urlPostFix != "") {
      urlPostFix += "&";  
    }

    urlPostFix += "&orderby=" + sortOption;
  }

  const defaultSortOption = $(filterSearchInfo.filterElement).find(".filter__results").attr("data-default-sort");

  if(defaultSortOption !== undefined) {
    if (urlPostFix != "") {
      urlPostFix += "&";  
    }

    urlPostFix += "&defaultorderby=" + defaultSortOption;
  }
  
  const searchFieldSelector = ".filter__search-input:not(.filter__search-input-menu)";
  const hasSearchField = $(searchFieldSelector).length > 0;

  // This only applies to search pages with a search input field, but the whole 'search' functionality is also used on pages where there is no search field (for example news block widgets)
  if (hasSearchField) {
    const searchVal = $(searchFieldSelector).val();
    if (urlPostFix != "") {
      urlPostFix += "&";  
    }

    urlPostFix += "search=" + searchVal;

    updateCurrentUrlParameter("search", searchVal.toString());
    setQueryParamOnSearchTabs();
  }

  let pageNoUrl : string = "/" + filterSearchInfo.pageNo;

  if (developMode) {
    pageNoUrl = "";
  }

  if (isAndOrFacetsSearch && filterCategories !== "") {
    // search via facets mbv categories and/or
    if (urlPostFix != "") {
      urlPostFix += "&";
    }
    urlPostFix += "documentcategoryids=" + filterCategories;
    updateCurrentUrlParameter("categories", filterCategoryCodeNames);
    setQueryParamOnSearchTabs();
  }

  const url = $(filterSearchInfo.filterElement).find(".filter__results").attr("data-search-url") + pageNoUrl + "?" + urlPostFix;
  
  let timeInterval = 500;
  if (!triggerWithDelay) {    
    timeInterval = 1;
  }

  storeTimerFunction(filterSearchInfo, url, oldSearchIndex, initFilter, timeInterval);
}

function storeTimerFunction(filterSearchInfo: IFilterSearchInfo, url: string, oldSearchIndex: number, initFilter: boolean, timeInterval: number){
  filterSearchInfo.storeTimer = setTimeout(function () {
    $.ajax({
      url: url
    }).done(function (data) {

      if (oldSearchIndex != filterSearchInfo.searchIndex) {
        return;
      }

      $(".filter__filter-result-title").removeClass("hidden");
      $(".filter__form").removeClass("hidden");

      $(".filter__container").removeAttr("data-search-initialised");

      if (typeof data != "undefined" && data !== null && typeof data.searchResults != "undefined") {
        let html = "";      

        $(".filter__search-tabs-container").removeClass("hidden");
        
        if (filterSearchInfo.pageNo == 1 && $(".filter__search-title").length > 0) {

          if (data.totalAmountOfResults == 1) {
            html += "<div class='filter__search-results-caption'>1 " + $(".filter__search-title").attr("data-result") + "</div>";
          } else
          if (data.totalAmountOfResults > 1) {
            html += "<div class='filter__search-results-caption'>" + data.totalAmountOfResults + " " + $(".filter__search-title").attr("data-results") + "</div>";
          } else {
            html += "<div class='filter__search-results-caption'>" + $(".filter__search-title").attr("data-title") + "</div>";
          }
        }

        if (data.totalAmountOfResults == 0) {
          $(".filter__container").attr("data-search-initialised", "1");

          if (typeof filterSearchInfo.noResultsTemplate !== "undefined") {
            html = filterSearchInfo.noResultsTemplate();
            $(filterSearchInfo.filterElement).find(".filter__results").html(html);
            $(".filter__search-container-results").removeClass("hidden");
            
            $(".filter__form input:checked").closest(".form-group").removeClass("hidden");
            $(".filter__form input:not(:checked)").closest(".form-group").addClass("hidden");

            $(".filter__form input:checked").closest(".form-sub-group").removeClass("hidden");
            $(".filter__form input:not(:checked)").closest(".form-sub-group").addClass("hidden");

            $(".filter__facet-group").each(function (index, element) {
              if ($(".filter__form input:checked").length == 0) {
                $(element).prev().addClass("hidden");
              }
            });

            return;
          }
        }

        // When there are results show the related activiteiten (this is a different way of searching and has a predefined of facets)
        if (data.totalAmountOfResults > 0 && $(filterSearchInfo.filterElement).closest(".related-activiteiten").length > 0) {
          $(filterSearchInfo.filterElement).closest(".related-activiteiten").removeClass("hidden");
          $(filterSearchInfo.filterElement).closest(".related-activiteiten").removeClass("d-none");
          $(filterSearchInfo.filterElement).closest(".widgets").removeClass("empty");
        } else
        if (data.totalAmountOfResults > 0 && $(filterSearchInfo.filterElement).closest(".related-kennisbank").length > 0) {
          $(filterSearchInfo.filterElement).closest(".related-kennisbank").removeClass("hidden");
          $(filterSearchInfo.filterElement).closest(".related-kennisbank").removeClass("d-none");
          $(filterSearchInfo.filterElement).closest(".widgets").removeClass("empty");
        }

        filterSearchInfo.resultsCount += data.searchResults.length;            

        data.searchResults.map((item : any, index : number) => {
          if (filterSearchInfo.maxItems !== -1 && index >= filterSearchInfo.maxItems) {
            return;
          }
          if (typeof filterSearchInfo.dateField != "undefined" && 
            filterSearchInfo.dateField != "" && 
            typeof item.Document[filterSearchInfo.dateField] != "undefined") {

            const date = new Date(item.Document[filterSearchInfo.dateField]);
            
            item.month = (<any> window).months[date.getMonth()];
            item.day = date.getDate();
            
            if (filterSearchInfo.groupMode == "month") {
              let monthYear = (<any> window).monthFull[date.getMonth()] + " " + date.getFullYear();

              if (monthYear != filterSearchInfo.currentMonth || filterSearchInfo.currentMonth == "") {
                html += filterSearchInfo.groupTemplate({titel : monthYear});
              }

              filterSearchInfo.currentMonth = monthYear;
            }
          }

          if (typeof item.Document["date"] != "undefined" &&  item.Document["date"] != null) {
            const date = new Date(item.Document["date"]);
            item.dateAsString = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
          } else if (typeof item.Document["documentlastpublished"] != "undefined" &&  item.Document["documentlastpublished"] != null) {
            const date = new Date(item.Document["documentlastpublished"]);
            item.dateAsString = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
          } else 
          {
            item.dateAsString = "";
          }

          if (item.Document["nieuwsfoto"]) {
            let nieuwsfoto = item.Document["nieuwsfoto"];
            if ((nieuwsfoto || "").indexOf("~") == 0) {
              nieuwsfoto = (nieuwsfoto || "").slice(1);
              if (nieuwsfoto.indexOf("?") >= 0) {
                nieuwsfoto += "&type=NieuwsOverzicht";
              } else {
                nieuwsfoto += "?type=NieuwsOverzicht";
              }
              item.Document["nieuwsfoto"] = nieuwsfoto;
            }
          }

          if (item.Document["teaserimage"]) {
            let teaserimage = item.Document["teaserimage"];

            if ((teaserimage || "").indexOf("~") == 0) {
              teaserimage = (teaserimage || "").slice(1);
              item.Document["teaserimage"] = teaserimage;
            }
          }

          let isDefaultRendering = true;
          if (item.Document && item.Document["classname"]) {
            const templateName = item.Document["classname"].replace(/\./g , "-");            
            const element = $("#" + templateName + "-template");
            if (element.length == 1) {
              const itemSource = element.html();
              let template = Handlebars.compile(itemSource);
              html += template(item);
              isDefaultRendering = false;
            }
          }

          if (isDefaultRendering) {
            html += filterSearchInfo.itemTemplate(item);
          }
        });
        
        if (filterSearchInfo.resultsCount < data.totalAmountOfResults) {        
          html += filterSearchInfo.loadMoreTemplate();        
        }

        if (initFilter) {
          $(filterSearchInfo.filterElement).find(".filter__results").html(html);
        } else {
          $(filterSearchInfo.filterElement).find(".filter__results").append(html);
        }

        if ($(".filter__filter-item-teaser").length > 0) {
          $(".filter__filter-item-teaser").ellipsis({count : 2, type : "lines"});
        }
        
        if (data.totalAmountOfResults > 0 && $(".filter__search-container-results").length > 0) {
          $(".filter__search-container-results").removeClass("hidden");
        }

        if (filterSearchInfo.resultsCount < data.totalAmountOfResults) {
          $(filterSearchInfo.filterElement).find(".filter__load-more").off("click");
          $(filterSearchInfo.filterElement).find(".filter__load-more").on("click", function (event) {
            event.preventDefault();
            filterSearchInfo.pageNo++;
            doFilter(false, false, false, filterSearchInfo);
            return false;
          });
        }

        // default geen zoek count
        $(".filter__form input").parent().find(".filter__count").text("(0)");

        $(".filter__form input:checked").closest(".form-group").removeClass("hidden");
        $(".filter__form input:not(:checked)").closest(".form-group").addClass("hidden");

        $(".filter__form input:checked").closest(".form-sub-group").removeClass("hidden");
        $(".filter__form input:not(:checked)").closest(".form-sub-group").addClass("hidden");

        for (let facet in data.searchableFacets) {
          if (data.searchableFacets.hasOwnProperty(facet)) {
            for (let field in data.searchableFacets[facet]) {
              if (data.searchableFacets[facet].hasOwnProperty(field)) {
                let count = data.searchableFacets[facet][field];
                $(".filter__form input[value='" + field + "']").closest(".form-group").removeClass("hidden");
                $(".filter__form input[value='" + field + "']").closest(".form-sub-group").removeClass("hidden");
                $(".filter__form input[value='" + field + "']").closest(".form-group").find(".filter__facet-accordion-toggle").removeClass("hidden");

                // activiteiten overzicht
                $(".filter__form h3[data-fieldname='" + facet + "']").siblings(".form-group").find("input[value='" + field + "']").parent().find(".filter__count").text("(" + count + ")");
                $(".filter__form h3[data-fieldname='" + facet + "']").siblings(".form-sub-group").find("input[value='" + field + "']").parent().find(".filter__count").text("(" + count + ")");
                // zoeken overzicht
                $(".filter__form input[value='" + field + "']").parent().find(".filter__count").text("(" + count + ")");
              }
            }
          }
        }

        $(".filter__facet-group").each(function (index, element) {
          if ($(element).find(".form-group:not(.hidden)").length == 0) {
            $(element).prev().addClass("hidden");
          } else {
            $(element).prev().removeClass("hidden");
          }
        });

        $(".form-group").each(function (index, element) {
          const hasAnySubGroupNotHidden = $(element).find(".form-sub-group:not(.hidden)").length > 0;
          if (!hasAnySubGroupNotHidden) {
            $(element).find(".filter__facet-accordion-toggle").first().addClass("hidden");
          }
        });

        $(".filter__facet-sub-group").each(function (index, element) {
          if ($(element).find(".form-sub-group:not(.hidden)").length == 0) {
            $(element).prev().addClass("hidden");
          } else {
            $(element).prev().removeClass("hidden");
          }
        });

        setupOpenContentInModal();
        setupFilterCategoryAccordion();

        initKaderlidInfoShowLessMore();

        EventManager.publish(EVENT_PAGESLIDER_ITEMS_LOADED);
      }
    });
  }, timeInterval);
}

function setupOpenContentInModal() {
  let isLoading = false;
  $(".content__open-modal").off("click");
  $(".content__open-modal").on("click", function(event) {
    event.preventDefault();
    if (!!isLoading) {
      return false;
    }
    isLoading = true;
    const pageUrl = $(this).attr("href");
    $.ajax({
      url: pageUrl + "?IsInModal=true"
    }).done(function(data) {
      isLoading = false;
      let gotoPageTitle = "";
      let filterContainer = $(".filter__container");
      if (filterContainer.length > 0) {
        gotoPageTitle = $(filterContainer[0]).attr("data-goto-page-button-text");
      }
      
      $('.content-modal').remove();
      let newDiv = $("<div />").append(data);
      $(newDiv).find("head").remove();
      $(newDiv).find("noscript").remove();
      $(newDiv).find("script").remove();
      $(newDiv).find("link").remove();
      $(newDiv).find(".cookiebanner ").remove();
      $(newDiv).find(".main-navbar ").remove();
      $(newDiv).find(".breadcrumbs ").remove();
      $(newDiv).find(".footer__fluid ").remove();
      $(newDiv).find(".colophon__fluid").remove();
      $(newDiv).find(".container.content").not(':first').remove();

      let result = `<div class="content-modal modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <a href="#" class="content-modal__back" data-dismiss="modal"><span class="icon icon-open-chevron-left"></span>Terug</a>
            <a href="#" class="icon icon-close content-modal__close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </a>
            <div class="modal-body">              
            </div>
            <a href="${pageUrl}" class="modal-content__goto-page btn btn-primary">${gotoPageTitle}</a>
          </div>
        </div>
      </div>`;
      $("body").append(result);
      $(".content-modal .modal-body").append(newDiv);
      $('.content-modal').modal('show');

      if (callBackInitializeContentModal) {
        callBackInitializeContentModal();
      }
    }).fail(function() {
      isLoading = false;
      location.href = pageUrl;
    });


    return false;
  });
}

function initInitialFilterValues(urlParams) {
  let categoriesParam = urlParams["categories"];
  if(categoriesParam != undefined
    && categoriesParam != "") {
      let selectedCategoryCodeNames = categoriesParam.split(",");
      (selectedCategoryCodeNames.forEach(selectedCategorCodeName => {
        let checkboxInput = <HTMLInputElement> document.getElementById("facetcategorie-" + selectedCategorCodeName);

        if(checkboxInput != undefined) {
          checkboxInput.checked = true;
        }
      }));
    }
}

function setQueryParamOnSearchTabs() {
    let tabOptionsElements = $(".filter__search-tabs-options a.dropdown-item");

    tabOptionsElements.each((i, element) =>
    {
      let currentUrl = <string> $(element).attr('href');
      if(currentUrl.includes("?"))
      {
        currentUrl = currentUrl.substring(0, currentUrl.indexOf("?"));
      }
      $(element).attr('href', currentUrl + window.location.search);
    });

}

function initKaderlidInfoShowLessMore() {
  $(".kadergroepen-info__show-more").off("click");
  $(".kadergroepen-info__show-more").on("click" , function (event) {
    event.preventDefault();
    $(this).closest(".body-text").find(".kadergroepen-info").addClass("open");
    return false;
  });

  $(".kadergroepen-info__show-less").off("click");
  $(".kadergroepen-info__show-less").on("click" , function (event) {
    event.preventDefault();
    $(this).closest(".body-text").find(".kadergroepen-info").removeClass("open");
    return false;
  });
}

let callBackInitializeContentModal;
export function initFilterController(initializeContentModal) {
  callBackInitializeContentModal = initializeContentModal;
  
  initKaderlidInfoShowLessMore();

  if ($(".filter").length > 0) {

    const urlParams = getAllUrlParams();
    if (urlParams["search"] !== undefined && urlParams["search"] !== "") {
      $(".filter__search-input:not(.filter__search-input-menu)").val(urlParams["search"]);
    }

    if ($(".filter").attr("data-develop") == "DEVELOP") {
      developMode = true;
    }

    registerHandlebarsHelpers();
    
    setupFilterMobile();

    initInitialFilterValues(urlParams);

    $(".filter").each(function(index, element) {
      let filterSearchInfo : IFilterSearchInfo = {
        itemTemplate : undefined,
        groupTemplate : undefined,
        loadMoreTemplate : undefined,
        noResultsTemplate : undefined,
        dateField : "",
        pageNo: 1,
        currentMonth : "",
        groupMode : "off",
        maxItems : -1,
        resultsCount : 0,
        filterElement : $(element),
        storeTimer : undefined,
        searchIndex : 1
      };
    
      filterSearchInfo.groupMode = $(element).attr("data-groupmode");
      filterSearchInfo.dateField = $(element).attr("data-dateField");

      const templateId = $(element).attr("data-filter-item-template-id");
      const templateItemGroupId = $(element).attr("data-filter-grouptitle-template-id");
      const loadMoreId = $(element).attr("data-load-more-template-id");

      if ($(element).attr("data-max-items") !== undefined) {
        filterSearchInfo.maxItems = parseFloat($(element).attr("data-max-items"));
      }

      if (templateId != "" && templateItemGroupId != "" && loadMoreId != "") {
        const itemSource = $("#" + templateId).html();
        filterSearchInfo.itemTemplate = Handlebars.compile(itemSource);

        const groupSource = $("#" + templateItemGroupId).html();
        filterSearchInfo.groupTemplate = Handlebars.compile(groupSource);

        const loadMoreSource   = $("#" + loadMoreId).html();
        filterSearchInfo.loadMoreTemplate = Handlebars.compile(loadMoreSource);

        if (typeof($(element).attr("data-filter-noresults-template-id")) !== "undefined" && 
          $(element).attr("data-filter-noresults-template-id") != "") {
          const noResultsSource = $("#" + $(element).attr("data-filter-noresults-template-id")).html();
          if (typeof noResultsSource !== "undefined") {
            filterSearchInfo.noResultsTemplate = Handlebars.compile(noResultsSource);
          }
        }

        $(".filter__remove-filters-link").on("click", function(event) { 
          let checkedBoxes = $(".filter__filter-options-container form input:checkbox:checked");
          checkedBoxes.each((_: number, element : HTMLElement) => {
            (element as HTMLInputElement).checked = false;
          });
          $(".filter__remove-filters-link").addClass("d-none");
          resetFilter(filterSearchInfo);
        });
        
        $(".filter__filter-options-container form input").on("click", function(event) {    
          const checkedBoxes = $(".filter__filter-options-container form input:checkbox:checked");
          if(checkedBoxes.length < 1){
            $(".filter__remove-filters-link").addClass("d-none");
          } else {
            $(".filter__remove-filters-link").removeClass("d-none");
          }
          doFilter(true, false, false, filterSearchInfo);
        });

        $(".filter__search-container form .input-group-append").on("click", function(event) {
          if ($(this).closest(".pagebuilder__widget-zoekbalk").length > 0) {
            return false;
          }

          doFilter(true, true, true, filterSearchInfo);
        });

        $(".filter__search-container form input").on("keydown", function(event) {
          if ($(this).closest(".pagebuilder__widget-zoekbalk").length > 0) {
            return false;
          }

          if(event.key == 'Enter'){
            event.preventDefault();
            doFilter(true, true, true, filterSearchInfo);
          }
        });

        $("#autocompleteList").on("click", function(event) {
          location.href = "zoeken?search=" + event.target.innerText;
        });

        $(".filter__search-sort-option").click(function (event) {
          event.preventDefault();
          $(".filter__search-sort-option").removeClass("active");
          $(this).addClass("active");
          $(".filter__search-sort-dropdown-toggle span").text( $.trim($(this).text()) );
          $(".filter__search-sort-dropdown-toggle").dropdown('toggle');
          doFilter(true, false, false, filterSearchInfo);
          return false;
        });

        if ($(".filter__search-container form input").length == 0) {
          // Trigger auto-search for nieuwsoverzicht & activiteiten
          doFilter(true, false, false, filterSearchInfo);
        } else {
          if ($(".filter__search-input:not(.filter__search-input-menu)").length > 0) {
            if ($(".filter__search-input:not(.filter__search-input-menu)").val() != "") {
              doFilter(true, false, false, filterSearchInfo);
            }
          }
        }

        $(".form-search").submit(function (event) {
          event.preventDefault();
          return false;
        });      
      }

      if ($(".filter__facet-group-title").length > 0) {
        doFilter(true, false, false, filterSearchInfo);
      }    
    });
  }
}

PluginManager.registerPlugin('filtercontroller', initFilterController);
